/**
 * @generated SignedSource<<5a724e08c2ff46305fe02ee75421e000>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type BookingSummaryQuery$variables = {
  bookingId: string;
  bookingType: BookingType;
  membershipTypeId: string;
  patronLoyalty: boolean;
};
export type BookingSummaryQuery$data = {
  readonly currentServerTime: string;
  readonly node: {
    readonly hasFullfillableMultipleSlotRequestSequence?: boolean;
    readonly rounds?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly bookingIndex: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"BookingSummary_booking">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly __typename: string;
        readonly club: {
          readonly slug: string;
          readonly " $fragmentSpreads": FragmentRefs<"BookingHeaderFragment_BookingSummary">;
        };
        readonly id?: string;
        readonly squareGiftCards?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"BookingSummaryMultipleViewSession_data" | "useCurrentUserHasSeenNotificationNudgeModal_session">;
  } | null | undefined;
};
export type BookingSummaryQuery = {
  response: BookingSummaryQuery$data;
  variables: BookingSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patronLoyalty"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentServerTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "Literal",
  "name": "hasNonZeroBalance",
  "value": true
},
v9 = {
  "alias": null,
  "args": [
    (v8/*: any*/)
  ],
  "concreteType": "SquareGiftCardConnection",
  "kind": "LinkedField",
  "name": "squareGiftCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareGiftCardEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCard",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "squareGiftCards(hasNonZeroBalance:true)"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bookingId"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bookingIndex",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasFullfillableMultipleSlotRequestSequence",
      "storageKey": null
    }
  ],
  "type": "StandardBooking",
  "abstractKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasSeenNotificationNudgeModal",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v18 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prePaymentRequirement",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientCanFulfillRequests",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singular",
  "storageKey": null
},
v25 = [
  (v24/*: any*/),
  (v23/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "NounOverride",
  "kind": "LinkedField",
  "name": "lessonPlayer",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = [
  (v24/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v29 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "RequestConfig",
  "kind": "LinkedField",
  "name": "requestConfig",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeCount",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v40 = [
  {
    "kind": "Literal",
    "name": "bookingType",
    "value": "STANDARD"
  }
],
v41 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v43 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CourseLayoutEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CourseLayout",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v44 = {
  "alias": "standardCapacity",
  "args": (v40/*: any*/),
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": "capacity(bookingType:\"STANDARD\")"
},
v45 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "bookingType",
      "variableName": "bookingType"
    }
  ],
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": null
},
v46 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isRound"
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUpdate",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "ownerClient",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v7/*: any*/),
      "type": "Customer",
      "abstractKey": null
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "round",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v55 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AppliedDiscount",
    "kind": "LinkedField",
    "name": "appliedDiscounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "squareExternalDiscountId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v56 = {
  "kind": "InlineFragment",
  "selections": (v55/*: any*/),
  "type": "RoundLineItem",
  "abstractKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": (v55/*: any*/),
  "type": "BookingLineItem",
  "abstractKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appliedAmount",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "squareExternalId",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineItemGroupId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderConnection",
  "kind": "LinkedField",
  "name": "orders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Order",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v36/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LineItemGroup",
              "kind": "LinkedField",
              "name": "lineItemGroups",
              "plural": true,
              "selections": [
                (v6/*: any*/),
                (v19/*: any*/),
                (v53/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "lineItems",
                  "plural": true,
                  "selections": [
                    (v6/*: any*/),
                    (v5/*: any*/),
                    (v19/*: any*/),
                    (v16/*: any*/),
                    (v54/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderDiscountConnection",
              "kind": "LinkedField",
              "name": "orderDiscounts",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderDiscountEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderDiscount",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v6/*: any*/),
                        (v16/*: any*/),
                        (v58/*: any*/),
                        (v59/*: any*/),
                        (v60/*: any*/),
                        (v61/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customCode",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseLayout",
  "kind": "LinkedField",
  "name": "courseLayout",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nonPlayingHost",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
},
v67 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
},
v68 = [
  {
    "kind": "Literal",
    "name": "highestPrecedentOnly",
    "value": true
  },
  (v41/*: any*/)
],
v69 = {
  "alias": "nineHolePrice",
  "args": [
    {
      "kind": "Literal",
      "name": "holeCount",
      "value": "NINE"
    }
  ],
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
},
v70 = {
  "alias": "eighteenHolePrice",
  "args": [
    {
      "kind": "Literal",
      "name": "holeCount",
      "value": "EIGHTEEN"
    }
  ],
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
},
v71 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "appliesToMembershipType",
    "storageKey": null
  },
  (v70/*: any*/),
  (v69/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v16/*: any*/),
      (v42/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dynamicEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dynamicOverridden",
            "storageKey": null
          }
        ],
        "type": "CustomerRate",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingPunchCount",
  "storageKey": null
},
v73 = [
  (v47/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v73/*: any*/),
      "type": "Member",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v73/*: any*/),
      "type": "Customer",
      "abstractKey": null
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calculationType",
  "storageKey": null
},
v76 = [
  (v6/*: any*/),
  (v72/*: any*/),
  (v74/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "punchPassTemplate",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v16/*: any*/),
      (v19/*: any*/),
      (v75/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  }
],
v77 = {
  "kind": "Literal",
  "name": "appliesTo",
  "value": "SELF"
},
v78 = {
  "kind": "Literal",
  "name": "valid",
  "value": true
},
v79 = [
  (v77/*: any*/),
  (v78/*: any*/)
],
v80 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "punchPassTemplate",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v19/*: any*/),
      (v6/*: any*/),
      (v16/*: any*/),
      (v75/*: any*/)
    ],
    "storageKey": null
  },
  (v72/*: any*/),
  (v74/*: any*/)
],
v81 = {
  "alias": "punchPassOptionsSelfValid",
  "args": (v79/*: any*/),
  "concreteType": "PunchPass",
  "kind": "LinkedField",
  "name": "punchPassOptions",
  "plural": true,
  "selections": (v80/*: any*/),
  "storageKey": "punchPassOptions(appliesTo:\"SELF\",valid:true)"
},
v82 = [
  {
    "kind": "Literal",
    "name": "appliesTo",
    "value": "OTHERS"
  },
  (v78/*: any*/)
],
v83 = {
  "alias": "punchPassOptionsOthersValid",
  "args": (v82/*: any*/),
  "concreteType": "PunchPass",
  "kind": "LinkedField",
  "name": "punchPassOptions",
  "plural": true,
  "selections": (v80/*: any*/),
  "storageKey": "punchPassOptions(appliesTo:\"OTHERS\",valid:true)"
},
v84 = {
  "kind": "Literal",
  "name": "valid",
  "value": false
},
v85 = [
  (v84/*: any*/)
],
v86 = {
  "alias": "punchPassOptionsInvalid",
  "args": (v85/*: any*/),
  "concreteType": "PunchPass",
  "kind": "LinkedField",
  "name": "punchPassOptions",
  "plural": true,
  "selections": (v80/*: any*/),
  "storageKey": "punchPassOptions(valid:false)"
},
v87 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminologyOther",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentSource",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ganLastFour",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareGiftCard",
  "kind": "LinkedField",
  "name": "squareGiftCard",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v90/*: any*/)
  ],
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDiscount",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaxes",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDueAfterCredits",
  "storageKey": null
},
v96 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RestrictionStatus",
    "kind": "LinkedField",
    "name": "statuses",
    "plural": true,
    "selections": [
      (v28/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "willViolate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "rule",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberOverride",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "staffOverride",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingRestrictionCountLimit",
                "kind": "LinkedField",
                "name": "countLimit",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countLimit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "qualifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeLimit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showNonViolating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingRuleBookingCriteria",
                "kind": "LinkedField",
                "name": "bookingCriteria",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minPlayers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxPlayers",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "BookingRestrictionRule",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v97 = [
  (v6/*: any*/),
  (v47/*: any*/)
],
v98 = {
  "kind": "InlineFragment",
  "selections": (v97/*: any*/),
  "type": "Customer",
  "abstractKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "bookingRule",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v32/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxRequestCount",
          "storageKey": null
        }
      ],
      "type": "RequestRule",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minTime",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxTime",
  "storageKey": null
},
v103 = [
  (v6/*: any*/),
  (v16/*: any*/)
],
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v105 = [
  (v6/*: any*/),
  (v104/*: any*/)
],
v106 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "ownerClient",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "active",
              "value": true
            },
            (v8/*: any*/)
          ],
          "concreteType": "SquareGiftCardConnection",
          "kind": "LinkedField",
          "name": "squareGiftCards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareGiftCardEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SquareGiftCard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v105/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "squareGiftCards(active:true,hasNonZeroBalance:true)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "expired",
              "value": false
            },
            (v8/*: any*/)
          ],
          "concreteType": "RaincheckConnection",
          "kind": "LinkedField",
          "name": "rainchecks",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RaincheckEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Raincheck",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "expirationDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareGiftCard",
                      "kind": "LinkedField",
                      "name": "squareGiftCard",
                      "plural": false,
                      "selections": [
                        (v104/*: any*/),
                        (v36/*: any*/),
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Facility",
                      "kind": "LinkedField",
                      "name": "facility",
                      "plural": false,
                      "selections": [
                        (v6/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RaincheckConfiguration",
                          "kind": "LinkedField",
                          "name": "raincheckConfiguration",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "limitRedemptionToFacility",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "rainchecks(expired:false,hasNonZeroBalance:true)"
        }
      ],
      "type": "Customer",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareGiftCardConnection",
  "kind": "LinkedField",
  "name": "paymentGiftCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareGiftCardEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCard",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v104/*: any*/),
            (v90/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "RaincheckConnection",
  "kind": "LinkedField",
  "name": "paymentRainchecks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RaincheckEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Raincheck",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareGiftCard",
              "kind": "LinkedField",
              "name": "squareGiftCard",
              "plural": false,
              "selections": (v105/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminologyOne",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v111 = {
  "alias": "patronOrders",
  "args": (v87/*: any*/),
  "concreteType": "OrderConnection",
  "kind": "LinkedField",
  "name": "orders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Order",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "condition": "patronLoyalty",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderAvailableLoyaltyRewards",
                  "kind": "LinkedField",
                  "name": "availableLoyaltyRewards",
                  "plural": false,
                  "selections": [
                    (v104/*: any*/),
                    (v109/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderLoyaltyRewardTier",
                      "kind": "LinkedField",
                      "name": "rewardTiers",
                      "plural": true,
                      "selections": [
                        (v36/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyRewardTier",
                          "kind": "LinkedField",
                          "name": "rewardTier",
                          "plural": false,
                          "selections": [
                            (v6/*: any*/),
                            (v16/*: any*/),
                            (v110/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderLoyaltyEnrollmentOffer",
                  "kind": "LinkedField",
                  "name": "loyaltyEnrollmentOffer",
                  "plural": false,
                  "selections": [
                    (v110/*: any*/),
                    (v109/*: any*/),
                    (v88/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SquareLoyaltyReward",
                  "kind": "LinkedField",
                  "name": "squareLoyaltyRewards",
                  "plural": true,
                  "selections": [
                    (v6/*: any*/),
                    (v110/*: any*/),
                    (v36/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "loyaltyCustomerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareLoyaltyAccount",
                      "kind": "LinkedField",
                      "name": "loyaltyAccount",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareLoyaltyRewardTier",
                      "kind": "LinkedField",
                      "name": "rewardTier",
                      "plural": false,
                      "selections": (v103/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v36/*: any*/),
                (v92/*: any*/),
                (v94/*: any*/),
                (v93/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "bookings",
                  "plural": true,
                  "selections": [
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v95/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Customer",
                  "kind": "LinkedField",
                  "name": "orderOwner",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareLoyaltyAccount",
                      "kind": "LinkedField",
                      "name": "squareLoyaltyAccount",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyAccountExpiringPointDeadline",
                          "kind": "LinkedField",
                          "name": "expiringPointDeadlines",
                          "plural": true,
                          "selections": [
                            (v6/*: any*/),
                            (v110/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "expiresAt",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Club",
                      "kind": "LinkedField",
                      "name": "club",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "timeZone",
                          "storageKey": null
                        },
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "orders(first:1)"
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesCount",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundableStatus",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesIndex",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "PunchPass",
  "kind": "LinkedField",
  "name": "appliedPunchPass",
  "plural": false,
  "selections": (v76/*: any*/),
  "storageKey": null
},
v116 = {
  "alias": "punchPassOptionsValid",
  "args": [
    (v78/*: any*/)
  ],
  "concreteType": "PunchPass",
  "kind": "LinkedField",
  "name": "punchPassOptions",
  "plural": true,
  "selections": (v76/*: any*/),
  "storageKey": "punchPassOptions(valid:true)"
},
v117 = {
  "alias": "punchPassOptionsInvalid",
  "args": (v85/*: any*/),
  "concreteType": "PunchPass",
  "kind": "LinkedField",
  "name": "punchPassOptions",
  "plural": true,
  "selections": (v76/*: any*/),
  "storageKey": "punchPassOptions(valid:false)"
},
v118 = [
  (v5/*: any*/),
  (v16/*: any*/),
  (v6/*: any*/)
],
v119 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RestrictionStatus",
    "kind": "LinkedField",
    "name": "statuses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "restriction",
        "plural": false,
        "selections": (v118/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleStatuses",
  "kind": "LinkedField",
  "name": "restrictionStatuses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GroupBookingRuleStatus",
      "kind": "LinkedField",
      "name": "groupStatuses",
      "plural": false,
      "selections": (v119/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundBookingRuleStatus",
      "kind": "LinkedField",
      "name": "roundStatuses",
      "plural": true,
      "selections": (v119/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v121 = {
  "condition": "patronLoyalty",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectedCreditApplication",
      "kind": "LinkedField",
      "name": "projectedCreditApplications",
      "plural": true,
      "selections": [
        (v59/*: any*/),
        (v89/*: any*/),
        (v91/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Raincheck",
          "kind": "LinkedField",
          "name": "raincheck",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v122 = [
  (v6/*: any*/),
  (v72/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "client",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v98/*: any*/),
      (v15/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "punchPassTemplate",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v16/*: any*/),
      (v75/*: any*/),
      (v19/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  }
],
v123 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LineItemGroup",
                  "kind": "LinkedField",
                  "name": "lineItemGroups",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "round",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "player",
                          "plural": false,
                          "selections": (v18/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPass",
                      "plural": false,
                      "selections": (v122/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": "punchPassesSelfValid",
                      "args": (v79/*: any*/),
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPassOptions",
                      "plural": true,
                      "selections": (v122/*: any*/),
                      "storageKey": "punchPassOptions(appliesTo:\"SELF\",valid:true)"
                    },
                    {
                      "alias": "punchPassesOthersValid",
                      "args": (v82/*: any*/),
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPassOptions",
                      "plural": true,
                      "selections": (v122/*: any*/),
                      "storageKey": "punchPassOptions(appliesTo:\"OTHERS\",valid:true)"
                    },
                    {
                      "alias": "punchPassesSelfInvalid",
                      "args": [
                        (v77/*: any*/),
                        (v84/*: any*/)
                      ],
                      "concreteType": "PunchPass",
                      "kind": "LinkedField",
                      "name": "punchPassOptions",
                      "plural": true,
                      "selections": (v122/*: any*/),
                      "storageKey": "punchPassOptions(appliesTo:\"SELF\",valid:false)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingSummaryQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useCurrentUserHasSeenNotificationNudgeModal_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingSummaryMultipleViewSession_data"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v9/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BookingHeaderFragment_BookingSummary"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "patronLoyalty",
                    "variableName": "patronLoyalty"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "BookingSummary_booking"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundConnection",
                "kind": "LinkedField",
                "name": "rounds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookingSummaryQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "membershipType",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MemberProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agenda",
                    "kind": "LinkedField",
                    "name": "agenda",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whooshBookingFee",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whooshRoundFee",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PublicBookingPermissionSet",
                            "kind": "LinkedField",
                            "name": "publicBookingPermissionSet",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v6/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rateDisplay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerCanSelectCourt",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Department",
                            "kind": "LinkedField",
                            "name": "department",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Club",
                                "kind": "LinkedField",
                                "name": "club",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PrivateBookingPermissionSet",
                            "kind": "LinkedField",
                            "name": "privateBookingPermissionSet",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canTransferBookingOwnership",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "membersCanMakeRecurringRequests",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Club",
                            "kind": "LinkedField",
                            "name": "club",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "supportsPrivate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarStartDay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhoneNumber",
                                "kind": "LinkedField",
                                "name": "phoneNumber",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formattedNumber",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "acceptsCreditCard",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "acceptsGiftCard",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "acceptsRaincheck",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityCopyOverrides",
                            "kind": "LinkedField",
                            "name": "copyOverrides",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NounOverride",
                                "kind": "LinkedField",
                                "name": "bookingPlayer",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NounOverride",
                                "kind": "LinkedField",
                                "name": "course",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NounOverride",
                                "kind": "LinkedField",
                                "name": "lesson",
                                "plural": false,
                                "selections": (v27/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberHoldEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberHoldDeadlineHours",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseConnection",
                            "kind": "LinkedField",
                            "name": "courses",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "patronRecurringRequestMaximumEndDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PrivateLessonsPermissionSet",
                            "kind": "LinkedField",
                            "name": "privateLessonsPermissionSet",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showPrices",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "patronAccess",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bookingPolicy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showBookingPolicy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lessonsPolicy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showLessonsPolicy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NotificationSettings",
                            "kind": "LinkedField",
                            "name": "bookingNotificationSettings",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": [
                                      "ACCESS_CODE"
                                    ]
                                  }
                                ],
                                "concreteType": "NotifiableEventSettingsConnection",
                                "kind": "LinkedField",
                                "name": "notifiableEventSettings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NotifiableEventSettingsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NotifiableEventSettings",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sendBeforeTimeAmount",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sendBeforeTimeUnit",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "notifiableEventSettings(type:[\"ACCESS_CODE\"])"
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": "configuredRequestRestrictions",
                        "args": (v29/*: any*/),
                        "concreteType": "AgendaBookingRulesConnection",
                        "kind": "LinkedField",
                        "name": "requestWindowBookingRules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgendaBookingRulesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v30/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v32/*: any*/)
                                    ],
                                    "type": "RequestRule",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                      },
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                          }
                        ],
                        "concreteType": "TimeSlotConnection",
                        "kind": "LinkedField",
                        "name": "timeSlots",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlotEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlot",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "timeSlots(first:1000)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgendaMemberNote",
                        "kind": "LinkedField",
                        "name": "memberNote",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "header",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                          },
                          (v36/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isSlot"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomerType",
                        "kind": "LinkedField",
                        "name": "defaultCustomerType",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Course",
                        "kind": "LinkedField",
                        "name": "course",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "remoteLockId",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseBucket",
                            "kind": "LinkedField",
                            "name": "courseBucket",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseLayout",
                            "kind": "LinkedField",
                            "name": "defaultCourseLayout",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseLayoutConnection",
                            "kind": "LinkedField",
                            "name": "courseLayouts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseLayoutEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseLayout",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v39/*: any*/),
                                      (v38/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lockedUntil",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v40/*: any*/),
                        "kind": "ScalarField",
                        "name": "availableCapacity",
                        "storageKey": "availableCapacity(bookingType:\"STANDARD\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requirePlayerCounts",
                        "storageKey": null
                      },
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WeatherCondition",
                        "kind": "LinkedField",
                        "name": "weatherCondition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "temperature",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "weatherCategory",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "measurementSystem",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "windSpeedInMph",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isInCancelWindow",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "usedCapacity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "highestPrecedentOnly",
                            "value": false
                          },
                          (v41/*: any*/),
                          {
                            "kind": "Variable",
                            "name": "visibleToMembershipTypeId",
                            "variableName": "membershipTypeId"
                          }
                        ],
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "bookingRates",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "membershipTypeId",
                                    "variableName": "membershipTypeId"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "appliesToMembershipType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "memberVisible",
                            "value": true
                          }
                        ],
                        "concreteType": "CourseLayoutConnection",
                        "kind": "LinkedField",
                        "name": "permittedCourseLayouts",
                        "plural": false,
                        "selections": (v43/*: any*/),
                        "storageKey": "permittedCourseLayouts(memberVisible:true)"
                      },
                      (v44/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingConnection",
                        "kind": "LinkedField",
                        "name": "bookings",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BookingEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoundConnection",
                                    "kind": "LinkedField",
                                    "name": "rounds",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoundEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v6/*: any*/),
                                              (v46/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "player",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  (v47/*: any*/),
                                                  (v6/*: any*/),
                                                  (v48/*: any*/),
                                                  (v49/*: any*/),
                                                  (v50/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "booking",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "startSlot",
                                                    "plural": false,
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Agenda",
                                                        "kind": "LinkedField",
                                                        "name": "agenda",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Facility",
                                                            "kind": "LinkedField",
                                                            "name": "facility",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "FacilityCopyOverrides",
                                                                "kind": "LinkedField",
                                                                "name": "copyOverrides",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "NounOverride",
                                                                    "kind": "LinkedField",
                                                                    "name": "lessonPlayer",
                                                                    "plural": false,
                                                                    "selections": (v27/*: any*/),
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "NounOverride",
                                                                    "kind": "LinkedField",
                                                                    "name": "bookingPlayer",
                                                                    "plural": false,
                                                                    "selections": (v27/*: any*/),
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v6/*: any*/),
                                                              (v19/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v6/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v6/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v6/*: any*/),
                                                  (v51/*: any*/),
                                                  (v52/*: any*/),
                                                  (v62/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TransportationType",
                                                "kind": "LinkedField",
                                                "name": "transportationType",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  (v39/*: any*/),
                                                  (v63/*: any*/),
                                                  (v16/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v64/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v65/*: any*/)
                                                ],
                                                "type": "MemberRound",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v66/*: any*/)
                                                ],
                                                "type": "CustomerRound",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "configuredRequestRestrictions",
                        "args": (v29/*: any*/),
                        "concreteType": "SlotBookingRulesConnection",
                        "kind": "LinkedField",
                        "name": "requestWindowBookingRules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SlotBookingRulesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v30/*: any*/),
                              (v31/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                      },
                      (v67/*: any*/)
                    ],
                    "type": "TimeSlot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "slotRates",
                        "args": (v68/*: any*/),
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "playerRates",
                        "plural": true,
                        "selections": [
                          (v69/*: any*/),
                          (v70/*: any*/)
                        ],
                        "storageKey": "playerRates(highestPrecedentOnly:true,type:\"CUSTOMER\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "agenda",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseLayoutConnection",
                                "kind": "LinkedField",
                                "name": "courseLayouts",
                                "plural": false,
                                "selections": (v43/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v67/*: any*/)
                    ],
                    "type": "QueueSlot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v34/*: any*/)
                    ],
                    "type": "BucketTimeSlot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundConnection",
                "kind": "LinkedField",
                "name": "rounds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v64/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TransportationType",
                            "kind": "LinkedField",
                            "name": "transportationType",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v6/*: any*/),
                              (v63/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CustomerType",
                                    "kind": "LinkedField",
                                    "name": "membershipType",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "Customer",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MembershipType",
                                    "kind": "LinkedField",
                                    "name": "membershipType",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroup",
                                    "kind": "LinkedField",
                                    "name": "memberGroups",
                                    "plural": true,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "Member",
                                "abstractKey": null
                              },
                              (v47/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TransportationType",
                            "kind": "LinkedField",
                            "name": "secondaryTransportationType",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualPaymentStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoundRate",
                            "kind": "LinkedField",
                            "name": "bookedRate",
                            "plural": false,
                            "selections": (v71/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoundRate",
                            "kind": "LinkedField",
                            "name": "roundRate",
                            "plural": false,
                            "selections": (v71/*: any*/),
                            "storageKey": null
                          },
                          (v66/*: any*/),
                          (v46/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "booking",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startSlot",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Agenda",
                                    "kind": "LinkedField",
                                    "name": "agenda",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Facility",
                                        "kind": "LinkedField",
                                        "name": "facility",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FacilityCopyOverrides",
                                            "kind": "LinkedField",
                                            "name": "copyOverrides",
                                            "plural": false,
                                            "selections": [
                                              (v26/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "NounOverride",
                                                "kind": "LinkedField",
                                                "name": "bookingPlayer",
                                                "plural": false,
                                                "selections": (v25/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v6/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PunchPass",
                            "kind": "LinkedField",
                            "name": "ratePunchPass",
                            "plural": false,
                            "selections": (v76/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PunchPass",
                            "kind": "LinkedField",
                            "name": "transportationPunchPass",
                            "plural": false,
                            "selections": (v76/*: any*/),
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v65/*: any*/),
                              (v81/*: any*/),
                              (v83/*: any*/),
                              (v86/*: any*/)
                            ],
                            "type": "MemberRound",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "host",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "GuestRound",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v81/*: any*/),
                              (v83/*: any*/),
                              (v86/*: any*/)
                            ],
                            "type": "CustomerRound",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteLockAccessCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingPaymentRequirements",
                "kind": "LinkedField",
                "name": "paymentRequirements",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requirePaymentCardOnFile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "squareAvailable",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "patronOrders",
                "args": (v87/*: any*/),
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "patronLoyalty",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expectedLoyaltyPoints",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderAvailableLoyaltyRewards",
                                "kind": "LinkedField",
                                "name": "availableLoyaltyRewards",
                                "plural": false,
                                "selections": [
                                  (v88/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "orders(first:1)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              (v51/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareCardOnFile",
                "kind": "LinkedField",
                "name": "paymentCardOnFile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cardBrand",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastFour",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrderPaymentConnection",
                            "kind": "LinkedField",
                            "name": "orderPayments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderPaymentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderPayment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v89/*: any*/),
                                      (v36/*: any*/),
                                      (v6/*: any*/),
                                      (v59/*: any*/),
                                      (v91/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "refundedAmount",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v36/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrderDiscountConnection",
                            "kind": "LinkedField",
                            "name": "orderDiscounts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderDiscountEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderDiscount",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v58/*: any*/),
                                      (v59/*: any*/),
                                      (v60/*: any*/),
                                      (v6/*: any*/),
                                      (v16/*: any*/),
                                      (v61/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LineItemGroup",
                            "kind": "LinkedField",
                            "name": "lineItemGroups",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "lineItems",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  (v57/*: any*/),
                                  (v56/*: any*/),
                                  (v6/*: any*/),
                                  (v16/*: any*/),
                                  (v54/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "quantity",
                                    "storageKey": null
                                  },
                                  (v92/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v53/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ServiceChargeConnection",
                            "kind": "LinkedField",
                            "name": "serviceCharges",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ServiceChargeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v59/*: any*/),
                                      (v6/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPaid",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v95/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PromoCode",
                "kind": "LinkedField",
                "name": "appliedPromoCode",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "replacesBookingId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestSubmissionBlocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingSeries",
                "kind": "LinkedField",
                "name": "bookingSeries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recurrenceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "repeatInterval",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCondition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveEndDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestedOccurrenceCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 366
                      },
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          {
                            "direction": "DESC",
                            "field": "DATE_TIME"
                          }
                        ]
                      }
                    ],
                    "concreteType": "BookingConnection",
                    "kind": "LinkedField",
                    "name": "bookings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startSlot",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Agenda",
                                    "kind": "LinkedField",
                                    "name": "agenda",
                                    "plural": false,
                                    "selections": [
                                      (v33/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "bookings(first:366,orderBy:[{\"direction\":\"DESC\",\"field\":\"DATE_TIME\"}])"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingRuleStatuses",
                "kind": "LinkedField",
                "name": "restrictionStatuses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupBookingRuleStatus",
                    "kind": "LinkedField",
                    "name": "groupStatuses",
                    "plural": false,
                    "selections": (v96/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundBookingRuleStatus",
                    "kind": "LinkedField",
                    "name": "roundStatuses",
                    "plural": true,
                    "selections": (v96/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RequestRestrictionStatus",
                "kind": "LinkedField",
                "name": "requestRestrictionStatuses",
                "plural": true,
                "selections": [
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blockingScope",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notesFromMember",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerClient",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v97/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  (v15/*: any*/),
                  (v98/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "rate",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "writeAccess",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v36/*: any*/),
                  (v99/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Request",
                    "kind": "LinkedField",
                    "name": "request",
                    "plural": false,
                    "selections": [
                      (v100/*: any*/),
                      (v6/*: any*/),
                      (v34/*: any*/),
                      (v101/*: any*/),
                      (v102/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RequestCoursePreference",
                        "kind": "LinkedField",
                        "name": "requestCoursePreferences",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "index",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Course",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": (v103/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseBucket",
                            "kind": "LinkedField",
                            "name": "courseBucket",
                            "plural": false,
                            "selections": (v103/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v106/*: any*/),
                  (v107/*: any*/),
                  (v108/*: any*/),
                  (v111/*: any*/),
                  (v112/*: any*/),
                  (v66/*: any*/),
                  (v113/*: any*/),
                  (v114/*: any*/),
                  (v115/*: any*/),
                  (v116/*: any*/),
                  (v117/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlot",
                    "kind": "LinkedField",
                    "name": "fullfillableSlots",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Course",
                        "kind": "LinkedField",
                        "name": "course",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "slotRates",
                        "args": (v68/*: any*/),
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "playerRates",
                        "plural": true,
                        "selections": [
                          (v69/*: any*/),
                          (v70/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": (v118/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "playerRates(highestPrecedentOnly:true,type:\"CUSTOMER\")"
                      }
                    ],
                    "storageKey": null
                  },
                  (v120/*: any*/),
                  (v121/*: any*/),
                  (v123/*: any*/)
                ],
                "type": "StandardBooking",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v36/*: any*/),
                  (v99/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Request",
                    "kind": "LinkedField",
                    "name": "request",
                    "plural": false,
                    "selections": [
                      (v100/*: any*/),
                      (v6/*: any*/),
                      (v34/*: any*/),
                      (v101/*: any*/),
                      (v102/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v106/*: any*/),
                  (v107/*: any*/),
                  (v108/*: any*/),
                  (v111/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonType",
                    "kind": "LinkedField",
                    "name": "lessonType",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v6/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v112/*: any*/),
                  (v113/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StaffProfileConnection",
                    "kind": "LinkedField",
                    "name": "instructors",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StaffProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StaffProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StaffUser",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v47/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v114/*: any*/),
                  (v66/*: any*/),
                  (v115/*: any*/),
                  (v116/*: any*/),
                  (v117/*: any*/),
                  (v120/*: any*/),
                  (v121/*: any*/),
                  (v123/*: any*/)
                ],
                "type": "LessonBooking",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partySize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dietaryTags",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "occasionTags",
                    "storageKey": null
                  }
                ],
                "type": "DiningBooking",
                "abstractKey": null
              },
              {
                "condition": "patronLoyalty",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "patronOrders",
                    "args": (v87/*: any*/),
                    "concreteType": "OrderConnection",
                    "kind": "LinkedField",
                    "name": "orders",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Order",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SquareLoyaltyReward",
                                "kind": "LinkedField",
                                "name": "squareLoyaltyRewards",
                                "plural": true,
                                "selections": [
                                  (v36/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "orders(first:1)"
                  }
                ]
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e96081d661d48a37d6597c8e217699a",
    "id": null,
    "metadata": {},
    "name": "BookingSummaryQuery",
    "operationKind": "query",
    "text": "query BookingSummaryQuery(\n  $bookingId: ID!\n  $membershipTypeId: ID!\n  $bookingType: BookingType!\n  $patronLoyalty: Boolean!\n) {\n  currentServerTime\n  session {\n    ...useCurrentUserHasSeenNotificationNudgeModal_session\n    ...BookingSummaryMultipleViewSession_data\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Member {\n          id\n        }\n        ... on Customer {\n          id\n          squareGiftCards(hasNonZeroBalance: true) {\n            edges {\n              node {\n                id\n              }\n            }\n          }\n        }\n        club {\n          slug\n          ...BookingHeaderFragment_BookingSummary\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  node(id: $bookingId) {\n    __typename\n    ... on Booking {\n      __isBooking: __typename\n      ...BookingSummary_booking_3CuyyL\n      rounds {\n        edges {\n          node {\n            __typename\n            bookingIndex\n            id\n          }\n        }\n      }\n    }\n    ... on StandardBooking {\n      hasFullfillableMultipleSlotRequestSequence\n    }\n    id\n  }\n}\n\nfragment AddMorePlayersButton_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  canUpdate\n  ...useGetIsBookingFull_Booking\n  ...EditBookingModal_Booking\n  ... on StandardBooking {\n    paymentStatus\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        copyOverrides {\n          lessonPlayer {\n            plural\n          }\n          bookingPlayer {\n            plural\n          }\n        }\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        paymentStatus\n        id\n      }\n    }\n  }\n}\n\nfragment AddNewPlayersHeaderNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    bookings {\n      edges {\n        node {\n          __typename\n          id\n          rounds {\n            edges {\n              node {\n                __typename\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AddOrReplacePlayerPrivateStep_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  type\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      ...AddNewPlayersHeaderNode\n      standardCapacity: capacity(bookingType: STANDARD)\n      usedCapacity\n      requirePlayerCounts\n      course {\n        id\n        name\n        defaultCourseLayout {\n          id\n          holeCount\n        }\n        courseLayouts {\n          edges {\n            node {\n              id\n              code\n              holeCount\n              name\n            }\n          }\n        }\n      }\n    }\n    ... on QueueSlot {\n      __typename\n      ...AddNewPlayersHeaderNode\n    }\n    club {\n      id\n    }\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment AddPlayerStep_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n    club {\n      id\n    }\n  }\n}\n\nfragment ApplyPunchPassModalContent_Booking on Booking {\n  __isBooking: __typename\n  id\n  ownerClient {\n    __typename\n    ... on Member {\n      fullName\n    }\n    ... on Customer {\n      fullName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        ratePunchPass {\n          id\n        }\n        transportationPunchPass {\n          id\n        }\n        ...RoundPunchPassContent_Round\n      }\n    }\n  }\n  ... on StandardBooking {\n    appliedPunchPass {\n      id\n    }\n  }\n  ... on LessonBooking {\n    appliedPunchPass {\n      id\n    }\n  }\n  ...BookingPunchPassContent_Booking\n}\n\nfragment AvailableTeeTimes_booking on Booking {\n  __isBooking: __typename\n  ... on LessonBooking {\n    status\n  }\n  startSlot {\n    __typename\n    ...useHasUnpublishedRequestRestrictions_slot\n    agenda {\n      facility {\n        club {\n          supportsPublic\n          id\n        }\n        courses {\n          count\n        }\n        privateBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        publicBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  rounds {\n    count\n    edges {\n      node {\n        __typename\n        courseLayout {\n          holeCount\n          id\n        }\n        id\n      }\n    }\n  }\n  requestRestrictionStatuses {\n    type\n    blockingScope\n  }\n  ...useGetFullfillableSlots_booking\n  ... on StandardBooking {\n    status\n  }\n}\n\nfragment BookingActionsSection_Booking on Booking {\n  __isBooking: __typename\n  id\n  notesFromMember\n  canUpdate\n  ...JoinBookingButton_Booking\n  ...CancelBookingButton_Booking\n  ...MoveBookingButton_Booking\n  ...EditBookingButton_Booking\n  ...BookingOwner_Booking\n}\n\nfragment BookingCharges_booking_3CuyyL on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    prePaymentRequirement\n  }\n  id\n  __typename\n  patronOrders: orders(first: 1) {\n    edges {\n      node {\n        expectedLoyaltyPoints @include(if: $patronLoyalty)\n        availableLoyaltyRewards @include(if: $patronLoyalty) {\n          terminologyOther\n        }\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        acceptsCreditCard\n        id\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    status\n  }\n  ... on LessonBooking {\n    status\n  }\n  ... on DiningBooking {\n    status\n  }\n  ...BookingPaymentMethodSelect_booking\n  ...useGetSummaryCalculations_Booking\n  ...BookingCredits_booking_3CuyyL\n  ...BookingLoyaltyRewards_booking_3CuyyL\n}\n\nfragment BookingConfirmedModalShareSection_Booking on Booking {\n  __isBooking: __typename\n  id\n  shareUrl\n}\n\nfragment BookingConfirmedModal_Booking on Booking {\n  __isBooking: __typename\n  id\n  startSlot {\n    __typename\n    type\n    ... on TimeSlot {\n      availableCapacity(bookingType: STANDARD)\n      requirePlayerCounts\n    }\n    agenda {\n      date\n      facility {\n        slug\n        type\n        club {\n          slug\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  __typename\n  ... on StandardBooking {\n    status\n    paymentStatus\n    rounds {\n      edges {\n        node {\n          __typename\n          player {\n            __typename\n            id\n          }\n          ... on CustomerRound {\n            id\n            paymentStatus\n          }\n          id\n        }\n      }\n    }\n  }\n  ...BookingConfirmedModalShareSection_Booking\n}\n\nfragment BookingCreditSelectModals_booking on Booking {\n  __isBooking: __typename\n  id\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        id\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    paymentGiftCards {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    paymentRainchecks {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  ... on LessonBooking {\n    paymentGiftCards {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    paymentRainchecks {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment BookingCredits_booking_3CuyyL on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    prePaymentRequirement\n  }\n  id\n  source\n  __typename\n  appliedPromoCode {\n    id\n  }\n  orders {\n    edges {\n      node {\n        status\n        orderPayments {\n          edges {\n            node {\n              amount\n              refundedAmount\n              status\n              paymentSource\n              squareGiftCard {\n                id\n                ganLastFour\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  patronOrders: orders(first: 1) @include(if: $patronLoyalty) {\n    edges {\n      node {\n        squareLoyaltyRewards {\n          status\n          id\n        }\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        id\n        acceptsGiftCard\n        acceptsRaincheck\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    totalDueAfterCredits\n    status\n    projectedCreditApplications @include(if: $patronLoyalty) {\n      amount\n      paymentSource\n      squareGiftCard {\n        id\n        ganLastFour\n      }\n      raincheck {\n        id\n      }\n    }\n    ownerClient {\n      __typename\n      ... on Customer {\n        id\n        squareGiftCards(active: true, hasNonZeroBalance: true) {\n          edges {\n            node {\n              id\n              balance\n            }\n          }\n        }\n        rainchecks(expired: false, hasNonZeroBalance: true) {\n          edges {\n            node {\n              id\n              expirationDate\n              squareGiftCard {\n                balance\n                status\n                id\n              }\n              facility {\n                id\n                raincheckConfiguration {\n                  limitRedemptionToFacility\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    paymentGiftCards {\n      edges {\n        node {\n          ...BookingPaymentGiftCard_SquareGiftCard\n          id\n          balance\n          ganLastFour\n        }\n      }\n    }\n    paymentRainchecks {\n      edges {\n        node {\n          ...BookingPaymentRaincheck_Raincheck\n          id\n        }\n      }\n    }\n  }\n  ... on LessonBooking {\n    totalDueAfterCredits\n    status\n    projectedCreditApplications @include(if: $patronLoyalty) {\n      amount\n      paymentSource\n      squareGiftCard {\n        id\n        ganLastFour\n      }\n      raincheck {\n        id\n      }\n    }\n    ownerClient {\n      __typename\n      ... on Customer {\n        id\n        squareGiftCards(active: true, hasNonZeroBalance: true) {\n          edges {\n            node {\n              id\n              balance\n            }\n          }\n        }\n        rainchecks(expired: false, hasNonZeroBalance: true) {\n          edges {\n            node {\n              id\n              expirationDate\n              squareGiftCard {\n                balance\n                status\n                id\n              }\n              facility {\n                id\n                raincheckConfiguration {\n                  limitRedemptionToFacility\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    paymentGiftCards {\n      edges {\n        node {\n          ...BookingPaymentGiftCard_SquareGiftCard\n          id\n          balance\n          ganLastFour\n        }\n      }\n    }\n    paymentRainchecks {\n      edges {\n        node {\n          ...BookingPaymentRaincheck_Raincheck\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment BookingDetailsView_Booking on Booking {\n  __isBooking: __typename\n  id\n  type\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n    id\n  }\n  notesFromMember\n  ...useGetBookingRestrictionStatusesFragment\n  ...CancelBookingButton_Booking\n  ...MoveBookingButton_Booking\n  ...EditBookingButton_Booking\n  ...BookingActionsSection_Booking\n  ...useIsViewMoreVisible_Booking\n  ...RequestDetails_booking\n  ...RecurringRequestSeriesCard_booking\n  ...useRecurringRequestSeriesPreview_booking\n  ...useRequestRestrictionStatuses_booking\n  ...useIsAnyDynamicRateOnBookingLocked_Booking\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ...RoundList_Booking\n  ...useGetSummaryCalculations_Booking\n  ...ApplyPunchPassModalContent_Booking\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment BookingDurationCourtFragment on Slot {\n  __isSlot: __typename\n  id\n  ...BookingDurationCourtInnerFragment\n  ... on TimeSlot {\n    course {\n      id\n      courseBucket {\n        id\n      }\n    }\n    time\n  }\n  agenda {\n    id\n    facility {\n      publicBookingPermissionSet {\n        customerCanSelectCourt\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment BookingDurationCourtInnerFragment on Slot {\n  __isSlot: __typename\n  id\n  ... on TimeSlot {\n    id\n    time\n    course {\n      id\n      name\n      description\n      courseBucket {\n        id\n      }\n    }\n  }\n  agenda {\n    id\n    facility {\n      publicBookingPermissionSet {\n        customerCanSelectCourt\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment BookingHeaderFragment_BookingSummary on Club {\n  name\n  ...ClubLogo_Club\n}\n\nfragment BookingHeaderFragment_booking on Booking {\n  __isBooking: __typename\n  ... on StandardBooking {\n    status\n  }\n  ... on LessonBooking {\n    status\n  }\n}\n\nfragment BookingInfo_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  startSlot {\n    __typename\n    ... on BucketTimeSlot {\n      time\n    }\n    ... on TimeSlot {\n      time\n      dateTime\n      weatherCondition {\n        temperature\n        weatherCategory\n        measurementSystem\n        windSpeedInMph\n        id\n      }\n      course {\n        name\n        id\n      }\n    }\n    agenda {\n      date\n      facility {\n        type\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n  bookingSeries {\n    recurrenceType\n    repeatInterval\n    endCondition\n    effectiveEndDate\n    requestedOccurrenceCount\n    bookings(first: 366, orderBy: [{field: DATE_TIME, direction: DESC}]) {\n      edges {\n        node {\n          __typename\n          id\n          startSlot {\n            __typename\n            agenda {\n              date\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BookingLoyaltyRewards_booking_3CuyyL on Booking {\n  __isBooking: __typename\n  id\n  ... on StandardBooking {\n    status\n    patronOrders: orders(first: 1) {\n      edges {\n        node {\n          availableLoyaltyRewards @include(if: $patronLoyalty) {\n            balance\n          }\n          loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n            points\n          }\n          squareLoyaltyRewards @include(if: $patronLoyalty) {\n            id\n            points\n            status\n            loyaltyCustomerId\n            loyaltyAccount {\n              id\n            }\n            rewardTier {\n              id\n              name\n            }\n          }\n          ...PatronCheckoutLoyaltyRewards_order @include(if: $patronLoyalty)\n          ...PatronCheckoutLoyaltyRewardsEnrollmentOffer_order @include(if: $patronLoyalty)\n          id\n        }\n      }\n    }\n  }\n  ... on LessonBooking {\n    status\n    patronOrders: orders(first: 1) {\n      edges {\n        node {\n          availableLoyaltyRewards @include(if: $patronLoyalty) {\n            balance\n          }\n          loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n            points\n          }\n          squareLoyaltyRewards @include(if: $patronLoyalty) {\n            id\n            points\n            status\n            loyaltyCustomerId\n            loyaltyAccount {\n              id\n            }\n            rewardTier {\n              id\n              name\n            }\n          }\n          ...PatronCheckoutLoyaltyRewards_order @include(if: $patronLoyalty)\n          ...PatronCheckoutLoyaltyRewardsEnrollmentOffer_order @include(if: $patronLoyalty)\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment BookingOwner_Booking on Booking {\n  __isBooking: __typename\n  ownerClient {\n    __typename\n    ... on Customer {\n      id\n      fullName\n    }\n    ... on Member {\n      id\n      fullName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment BookingPaymentGiftCard_SquareGiftCard on SquareGiftCard {\n  id\n  balance\n  ganLastFour\n}\n\nfragment BookingPaymentMethodSelect_booking on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    requirePaymentCardOnFile\n    prePaymentRequirement\n  }\n  __typename\n  source\n  canUpdate\n  ... on StandardBooking {\n    status\n  }\n  ... on LessonBooking {\n    status\n  }\n  paymentCardOnFile {\n    ...PaymentMethod_squareCardOnFile\n    id\n  }\n  orders {\n    edges {\n      node {\n        orderPayments {\n          edges {\n            node {\n              paymentSource\n              status\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    agenda {\n      date\n      id\n    }\n    id\n  }\n}\n\nfragment BookingPaymentRaincheck_Raincheck on Raincheck {\n  id\n  createdAt\n  squareGiftCard {\n    id\n    balance\n  }\n}\n\nfragment BookingPayment_Booking_3CuyyL on Booking {\n  __isBooking: __typename\n  ...BookingReservation_Booking_3CuyyL\n  ...BookingPaymentMethodSelect_booking\n  ...ChargesSummary_booking_3CuyyL\n}\n\nfragment BookingPolicy_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        bookingPolicy\n        showBookingPolicy\n        lessonsPolicy\n        showLessonsPolicy\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment BookingPunchPassContent_Booking on Booking {\n  __isBooking: __typename\n  id\n  ownerClient {\n    __typename\n    ... on Member {\n      fullName\n    }\n    ... on Customer {\n      fullName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ... on StandardBooking {\n    appliedPunchPass {\n      id\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsValid: punchPassOptions(valid: true) {\n      id\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsInvalid: punchPassOptions(valid: false) {\n      id\n      ...PunchPassListItem_PunchPass\n    }\n  }\n  ... on LessonBooking {\n    appliedPunchPass {\n      id\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsValid: punchPassOptions(valid: true) {\n      id\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsInvalid: punchPassOptions(valid: false) {\n      id\n      ...PunchPassListItem_PunchPass\n    }\n  }\n}\n\nfragment BookingReservation_Booking_3CuyyL on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    requirePaymentCardOnFile\n    prePaymentRequirement\n    squareAvailable\n  }\n  replacesBookingId\n  requestSubmissionBlocked\n  id\n  __typename\n  orders {\n    edges {\n      node {\n        status\n        total\n        id\n      }\n    }\n  }\n  totalDueAfterCredits\n  paymentCardOnFile {\n    id\n  }\n  bookingSeries {\n    kind\n    id\n  }\n  ... on StandardBooking {\n    status\n    seriesCount\n    patronOrders: orders(first: 1) {\n      edges {\n        node {\n          loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n            points\n          }\n          id\n        }\n      }\n    }\n  }\n  ... on LessonBooking {\n    status\n    patronOrders: orders(first: 1) {\n      edges {\n        node {\n          loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n            points\n          }\n          id\n        }\n      }\n    }\n  }\n  ...useGetBookingRestrictionStatusesFragment\n  ...useRequestRestrictionStatuses_booking\n  startSlot {\n    __typename\n    id\n    type\n    ... on TimeSlot {\n      lockedUntil\n    }\n    agenda {\n      date\n      id\n      facility {\n        id\n        club {\n          supportsPrivate\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment BookingSummaryMultipleViewSession_data on Session {\n  ...useCurrentUserHasSeenNotificationNudgeModal_session\n  user {\n    __typename\n    id\n  }\n  currentClientProfile {\n    __typename\n    ... on MemberProfile {\n      member {\n        __typename\n        club {\n          slug\n          ...BookingHeaderFragment_BookingSummary\n          id\n        }\n        membershipType {\n          __typename\n          id\n        }\n        ... on Member {\n          id\n        }\n        ... on Customer {\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment BookingSummary_booking_3CuyyL on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  ...useGetBookingAnalyticsMetadata_booking\n  ...RemoteLockCode_Booking\n  ...ChargesSummary_booking_3CuyyL\n  ...PaymentCardEntryModals_booking\n  ...BookingPayment_Booking_3CuyyL\n  ...InviteOthersBox_Booking\n  ...BookingInfo_Booking\n  ...BookingDetailsView_Booking\n  ...BookingPolicy_Booking\n  ...BookingPaymentMethodSelect_booking\n  ...BookingReservation_Booking_3CuyyL\n  ...BookingHeaderFragment_booking\n  ...MemberNote_Booking\n  ...RequestInfoBanner_booking\n  ...LessonInfoBanner_booking\n  ...AvailableTeeTimes_booking\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ...BookingCreditSelectModals_booking\n  ...useGetFullfillableSlots_booking\n  ... on StandardBooking {\n    status\n    restrictionStatuses {\n      groupStatuses {\n        statuses {\n          restriction {\n            __typename\n            name\n            id\n          }\n        }\n      }\n      roundStatuses {\n        statuses {\n          restriction {\n            __typename\n            name\n            id\n          }\n        }\n      }\n    }\n    ...useInitializePunchPassesFromBooking\n  }\n  ... on LessonBooking {\n    status\n    restrictionStatuses {\n      groupStatuses {\n        statuses {\n          restriction {\n            __typename\n            name\n            id\n          }\n        }\n      }\n      roundStatuses {\n        statuses {\n          restriction {\n            __typename\n            name\n            id\n          }\n        }\n      }\n    }\n    ...useInitializePunchPassesFromBooking\n  }\n  ownerClient {\n    __typename\n    ... on Customer {\n      id\n    }\n    ... on Member {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  startSlot {\n    __typename\n    id\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          phoneNumber {\n            formattedNumber\n            id\n          }\n          id\n        }\n        privateLessonsPermissionSet {\n          patronAccess\n          id\n        }\n        ...RemoteLockCode_BookingSummaryRemoteLockCodeConfig\n        id\n      }\n      id\n    }\n  }\n  ...BookingConfirmedModal_Booking\n}\n\nfragment BundledRateAndTransportSelect_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          id\n          ... on Customer {\n            membershipType {\n              id\n            }\n          }\n          ... on Member {\n            membershipType {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment CancelBookingButton_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  bookingSeries {\n    id\n    kind\n  }\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ...CancelBookingModal_Booking\n  rounds {\n    count\n  }\n  ... on StandardBooking {\n    seriesCount\n    status\n    refundableStatus\n  }\n  ... on LessonBooking {\n    seriesCount\n    status\n    refundableStatus\n  }\n  startSlot {\n    id\n    __typename\n    ... on TimeSlot {\n      isInCancelWindow\n    }\n    agenda {\n      facility {\n        privateBookingPermissionSet {\n          canTransferBookingOwnership\n          id\n        }\n        club {\n          supportsPublic\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment CancelBookingModal_Booking on Booking {\n  __isBooking: __typename\n  ...ModalStepOutlet_CancelBooking_Booking\n  ...useInitializeCancelBookingModal_Booking\n}\n\nfragment CancelBooking_Booking on Booking {\n  __isBooking: __typename\n  id\n  startSlot {\n    __typename\n    id\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        player {\n          __typename\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ChargesSummary_booking_3CuyyL on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    ...NotificationsInner_slot\n    id\n  }\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ...BookingCharges_booking_3CuyyL\n  ...RequestChargesEstimation_booking\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ConsolidatedNewPlayers_Round on Round {\n  __isRound: __typename\n  id\n  booking {\n    __typename\n    startSlot {\n      __typename\n      agenda {\n        facility {\n          copyOverrides {\n            lessonPlayer {\n              plural\n            }\n            bookingPlayer {\n              plural\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ...useGetLineItemsAndPriceForRound_Round\n}\n\nfragment CourseLayoutControl_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      permittedCourseLayouts(memberVisible: true) {\n        edges {\n          node {\n            id\n            holeCount\n            code\n          }\n        }\n      }\n    }\n    ... on QueueSlot {\n      agenda {\n        facility {\n          courseLayouts {\n            edges {\n              node {\n                id\n                holeCount\n                code\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment DurationRoundControls_Booking on Booking {\n  __isBooking: __typename\n  id\n  ... on StandardBooking {\n    durationMins\n  }\n  rounds {\n    count\n  }\n}\n\nfragment EditBookingButton_Booking on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    prePaymentRequirement\n  }\n  id\n  __typename\n  canUpdate\n  source\n  appliedPromoCode {\n    id\n  }\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ...EditBookingModal_Booking\n  startSlot {\n    __typename\n    id\n  }\n}\n\nfragment EditBookingModal_Booking on Booking {\n  __isBooking: __typename\n  ...useInitializeEditBookingModal_Booking\n  ...ModalStepOutlet_Booking\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EditableRound_Booking on Booking {\n  __isBooking: __typename\n  ...RoundControls_Booking\n}\n\nfragment EditableRoundsList_Booking on Booking {\n  __isBooking: __typename\n  ...EditableRound_Booking\n}\n\nfragment EditableRoundsStep_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  ...EditableRoundsList_Booking\n  ...useGetBookingRestrictionStatusesFragment\n  ... on StandardBooking {\n    status\n    durationMins\n    request {\n      id\n    }\n  }\n  ... on LessonBooking {\n    durationMins\n    request {\n      id\n    }\n    lessonType {\n      id\n    }\n    instructors {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  rounds {\n    count\n  }\n  id\n  startSlot {\n    __typename\n    id\n    ...BookingDurationCourtFragment\n    ...BookingDurationCourtInnerFragment\n    agenda {\n      id\n      date\n      facility {\n        id\n        type\n        club {\n          supportsPrivate\n          id\n        }\n      }\n      ...RequestTimeSelectionControl_TimeSlots\n    }\n  }\n}\n\nfragment GolfPlayerRateControl_Booking on Booking {\n  __isBooking: __typename\n  ... on StandardBooking {\n    status\n  }\n  startSlot {\n    __typename\n    id\n    ... on TimeSlot {\n      agenda {\n        facility {\n          type\n          id\n        }\n        id\n      }\n    }\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          id\n          ... on Customer {\n            membershipType {\n              id\n            }\n          }\n          ... on Member {\n            membershipType {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GolfRoundControls_Booking on Booking {\n  __isBooking: __typename\n  ...CourseLayoutControl_Booking\n  ...GolfPlayerRateControl_Booking\n  ...BundledRateAndTransportSelect_Booking\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        publicBookingPermissionSet {\n          rateDisplay\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment InviteActions_Booking on Booking {\n  __isBooking: __typename\n  id\n  shareUrl\n}\n\nfragment InviteOthersBox_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      availableCapacity(bookingType: STANDARD)\n      requirePlayerCounts\n    }\n    agenda {\n      facility {\n        type\n        copyOverrides {\n          bookingPlayer {\n            plural\n          }\n        }\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  __typename\n  id\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ...InviteActions_Booking\n  ... on StandardBooking {\n    status\n    paymentStatus\n    rounds {\n      edges {\n        node {\n          __typename\n          player {\n            __typename\n            id\n          }\n          ... on CustomerRound {\n            id\n            paymentStatus\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment JoinBookingButton_Booking on Booking {\n  __isBooking: __typename\n  id\n  writeAccess\n}\n\nfragment LessonInfoBanner_booking on Booking {\n  __isBooking: __typename\n  __typename\n  ... on LessonBooking {\n    lessonType {\n      description\n      id\n    }\n  }\n}\n\nfragment MemberNote_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    agenda {\n      memberNote {\n        header\n        body\n        status\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ModalStepOutlet_Booking on Booking {\n  __isBooking: __typename\n  ...EditableRoundsStep_Booking\n  ...AddPlayerStep_Booking\n  ...AddOrReplacePlayerPrivateStep_Booking\n}\n\nfragment ModalStepOutlet_CancelBooking_Booking on Booking {\n  __isBooking: __typename\n  ...CancelBooking_Booking\n}\n\nfragment MoveBookingButton_Booking on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    prePaymentRequirement\n  }\n  id\n  source\n  type\n  ...useShouldPresentBookingAsLockedRequest_booking\n  ... on StandardBooking {\n    status\n  }\n  orders {\n    edges {\n      node {\n        isPaid\n        id\n      }\n    }\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      isInCancelWindow\n      time\n      course {\n        id\n      }\n    }\n    id\n    agenda {\n      facility {\n        type\n        id\n        slug\n      }\n      id\n      date\n    }\n  }\n  canUpdate\n}\n\nfragment NotificationsInner_slot on Slot {\n  __isSlot: __typename\n  agenda {\n    facility {\n      publicBookingPermissionSet {\n        clientCanFulfillRequests\n        id\n      }\n      privateBookingPermissionSet {\n        clientCanFulfillRequests\n        id\n      }\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment PatronCheckoutLoyaltyRewardsEnrollmentOffer_order on Order {\n  loyaltyEnrollmentOffer {\n    points\n    terminologyOne\n    terminologyOther\n  }\n}\n\nfragment PatronCheckoutLoyaltyRewards_order on Order {\n  id\n  status\n  total\n  totalTaxes\n  totalDiscount\n  bookings {\n    __typename\n    id\n    totalDueAfterCredits\n  }\n  expectedLoyaltyPoints\n  orderOwner {\n    squareLoyaltyAccount {\n      expiringPointDeadlines {\n        id\n        points\n        expiresAt\n      }\n      id\n    }\n    club {\n      timeZone\n      id\n    }\n    id\n  }\n  availableLoyaltyRewards {\n    balance\n    terminologyOne\n    terminologyOther\n    rewardTiers {\n      status\n      rewardTier {\n        id\n        name\n        points\n      }\n    }\n  }\n  squareLoyaltyRewards {\n    id\n    points\n    status\n    loyaltyCustomerId\n    loyaltyAccount {\n      id\n    }\n    rewardTier {\n      id\n      name\n    }\n  }\n}\n\nfragment PaymentCardEntryModals_booking on Booking {\n  __isBooking: __typename\n  id\n  ... on StandardBooking {\n    status\n  }\n  paymentCardOnFile {\n    id\n    cardBrand\n    lastFour\n    expMonth\n    expYear\n  }\n  startSlot {\n    __typename\n    agenda {\n      date\n      id\n    }\n    id\n  }\n}\n\nfragment PaymentMethod_squareCardOnFile on SquareCardOnFile {\n  id\n  expMonth\n  expYear\n  cardBrand\n  lastFour\n}\n\nfragment PunchPassListItem_PunchPass on PunchPass {\n  id\n  remainingPunchCount\n  client {\n    __typename\n    ... on Member {\n      fullName\n    }\n    ... on Customer {\n      fullName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  punchPassTemplate {\n    __typename\n    name\n    type\n    calculationType\n    id\n  }\n}\n\nfragment PunchPassSummary_Booking on Booking {\n  __isBooking: __typename\n  id\n  ownerClient {\n    __typename\n    ... on Member {\n      fullName\n    }\n    ... on Customer {\n      fullName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ... on StandardBooking {\n    paymentStatus\n  }\n  ... on LessonBooking {\n    paymentStatus\n  }\n}\n\nfragment RecurringRequestSeriesCard_booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  startSlot {\n    __typename\n    agenda {\n      date\n      facility {\n        ...useFacilityCourseNoun_facility\n        club {\n          calendarStartDay\n          supportsPrivate\n          supportsPublic\n          id\n        }\n        type\n        courses {\n          count\n        }\n        patronRecurringRequestMaximumEndDate\n        privateBookingPermissionSet {\n          membersCanMakeRecurringRequests\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    status\n    request {\n      time\n      minTime\n      maxTime\n      requestCoursePreferences {\n        index\n        course {\n          id\n          name\n        }\n        courseBucket {\n          id\n          name\n        }\n      }\n      id\n    }\n    seriesCount\n  }\n  bookingSeries {\n    id\n    recurrenceType\n    repeatInterval\n    endCondition\n    effectiveEndDate\n    requestedOccurrenceCount\n    bookings(first: 366, orderBy: [{field: DATE_TIME, direction: DESC}]) {\n      edges {\n        node {\n          __typename\n          id\n          startSlot {\n            __typename\n            agenda {\n              date\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RemoteLockCode_Booking on Booking {\n  __isBooking: __typename\n  remoteLockAccessCode\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      course {\n        remoteLockId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RemoteLockCode_BookingSummaryRemoteLockCodeConfig on Facility {\n  bookingNotificationSettings {\n    notifiableEventSettings(type: [ACCESS_CODE]) {\n      edges {\n        node {\n          id\n          type\n          sendBeforeTimeAmount\n          sendBeforeTimeUnit\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment RequestChargesEstimation_booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  ... on StandardBooking {\n    durationMins\n  }\n  ... on LessonBooking {\n    lessonType {\n      name\n      id\n    }\n    durationMins\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  rounds {\n    count\n    edges {\n      node {\n        __typename\n        courseLayout {\n          holeCount\n          id\n        }\n        id\n      }\n    }\n  }\n  ...useGetRequestSummaryEstimation_Booking\n}\n\nfragment RequestDetails_booking on Booking {\n  __isBooking: __typename\n  __typename\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        ...useFacilityCourseNoun_facility\n        copyOverrides {\n          lessonPlayer {\n            singular\n            plural\n          }\n          bookingPlayer {\n            singular\n            plural\n          }\n        }\n        courses {\n          count\n        }\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  rounds {\n    count\n    edges {\n      node {\n        __typename\n        courseLayout {\n          holeCount\n          id\n        }\n        id\n      }\n    }\n  }\n  ... on StandardBooking {\n    request {\n      time\n      minTime\n      maxTime\n      requestCoursePreferences {\n        index\n        course {\n          id\n          name\n        }\n        courseBucket {\n          id\n          name\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      time\n      minTime\n      maxTime\n      id\n    }\n  }\n  ...useShouldPresentBookingAsLockedRequest_booking\n}\n\nfragment RequestInfoBanner_booking on Booking {\n  __isBooking: __typename\n  __typename\n  ... on StandardBooking {\n    seriesCount\n    request {\n      time\n      id\n    }\n  }\n  ... on LessonBooking {\n    seriesCount\n    request {\n      time\n      id\n    }\n  }\n  bookingSeries {\n    recurrenceType\n    id\n  }\n  startSlot {\n    __typename\n    ... on QueueSlot {\n      agenda {\n        date\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RequestTimeSelectionControl_TimeSlots on Agenda {\n  id\n  timeSlots(first: 1000) {\n    edges {\n      node {\n        id\n        time\n        availability\n      }\n    }\n  }\n}\n\nfragment RoundControls_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  ...GolfRoundControls_Booking\n  ...DurationRoundControls_Booking\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment RoundInfoDisplay_Round on Round {\n  __isRound: __typename\n  booking {\n    __typename\n    canUpdate\n    startSlot {\n      __typename\n      agenda {\n        facility {\n          type\n          copyOverrides {\n            lessonPlayer {\n              singular\n            }\n            bookingPlayer {\n              singular\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    ownerClient {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n  __typename\n  id\n  transportationType {\n    id\n    code\n    customCode\n    name\n  }\n  courseLayout {\n    holeCount\n    id\n  }\n  ... on MemberRound {\n    nonPlayingHost\n  }\n  player {\n    __typename\n    id\n    fullName\n    firstName\n    lastName\n    profileImage {\n      publicId: renderingKey\n    }\n  }\n}\n\nfragment RoundListAdditionalBookingInfoItemDisplay_Booking on Booking {\n  __isBooking: __typename\n  id\n  ...useGetBookingFees_Booking\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      standardCapacity: capacity(bookingType: STANDARD)\n      course {\n        name\n        id\n      }\n    }\n    ... on QueueSlot {\n      standardCapacity: capacity(bookingType: STANDARD)\n    }\n    agenda {\n      facility {\n        copyOverrides {\n          course {\n            singular\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ...useGetSummaryCalculations_Booking\n  ... on StandardBooking {\n    durationMins\n    seriesIndex\n    seriesCount\n  }\n  ... on LessonBooking {\n    seriesIndex\n    seriesCount\n  }\n}\n\nfragment RoundListAdditionalBookingInfo_Booking on Booking {\n  __isBooking: __typename\n  ... on LessonBooking {\n    durationMins\n    lessonType {\n      id\n    }\n  }\n  rounds {\n    count\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        type\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  id\n  __typename\n  ...RoundListAdditionalBookingInfoItemDisplay_Booking\n  ...useGetBookingFees_Booking\n  ...useGetBookingCharge_Booking\n  ...RoundListAdditionalLessonInfoItemDisplay_Booking\n  ...useGetSummaryCalculations_Booking\n  ...PunchPassSummary_Booking\n}\n\nfragment RoundListAdditionalLessonInfoItemDisplay_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      course {\n        name\n        id\n      }\n    }\n    agenda {\n      facility {\n        copyOverrides {\n          course {\n            singular\n          }\n        }\n        club {\n          supportsPrivate\n          id\n        }\n        privateLessonsPermissionSet {\n          showPrices\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    seriesIndex\n    seriesCount\n  }\n  ... on LessonBooking {\n    seriesIndex\n    seriesCount\n    lessonType {\n      name\n      id\n    }\n    durationMins\n    instructors {\n      edges {\n        node {\n          user {\n            fullName\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment RoundList_Booking on Booking {\n  __isBooking: __typename\n  id\n  ...RoundListAdditionalBookingInfo_Booking\n  ...AddMorePlayersButton_Booking\n  ...useConsolidateNewPlayers_Booking\n  ...EditBookingModal_Booking\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      bookings {\n        count\n        edges {\n          node {\n            __typename\n            id\n            rounds {\n              edges {\n                node {\n                  __typename\n                  id\n                  ...Round_Round\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        bookingIndex\n        player {\n          __typename\n          id\n          fullName\n        }\n        ...Round_Round\n        ...ConsolidatedNewPlayers_Round\n      }\n    }\n  }\n}\n\nfragment RoundPunchPassContent_Round on Round {\n  __isRound: __typename\n  id\n  player {\n    __typename\n    fullName\n    id\n  }\n  ratePunchPass {\n    id\n    ...PunchPassListItem_PunchPass\n  }\n  transportationPunchPass {\n    id\n    ...PunchPassListItem_PunchPass\n  }\n  ... on MemberRound {\n    punchPassOptionsSelfValid: punchPassOptions(valid: true, appliesTo: SELF) {\n      id\n      punchPassTemplate {\n        __typename\n        type\n        id\n      }\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsOthersValid: punchPassOptions(valid: true, appliesTo: OTHERS) {\n      id\n      punchPassTemplate {\n        __typename\n        type\n        id\n      }\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsInvalid: punchPassOptions(valid: false) {\n      id\n      punchPassTemplate {\n        __typename\n        type\n        id\n      }\n      ...PunchPassListItem_PunchPass\n    }\n  }\n  ... on CustomerRound {\n    punchPassOptionsSelfValid: punchPassOptions(valid: true, appliesTo: SELF) {\n      id\n      punchPassTemplate {\n        __typename\n        type\n        id\n      }\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsOthersValid: punchPassOptions(valid: true, appliesTo: OTHERS) {\n      id\n      punchPassTemplate {\n        __typename\n        type\n        id\n      }\n      ...PunchPassListItem_PunchPass\n    }\n    punchPassOptionsInvalid: punchPassOptions(valid: false) {\n      id\n      punchPassTemplate {\n        __typename\n        type\n        id\n      }\n      ...PunchPassListItem_PunchPass\n    }\n  }\n}\n\nfragment Round_Round on Round {\n  __isRound: __typename\n  id\n  player {\n    __typename\n    fullName\n    id\n  }\n  booking {\n    __typename\n    startSlot {\n      __typename\n      agenda {\n        facility {\n          copyOverrides {\n            lessonPlayer {\n              singular\n            }\n            bookingPlayer {\n              singular\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ...RoundInfoDisplay_Round\n  ...useGetLineItemsAndPriceForRound_Round\n  ... on MemberRound {\n    nonPlayingHost\n  }\n}\n\nfragment getAggregatedOrderFinancialSummary_order on Order {\n  total\n  totalDiscount\n  totalTaxes\n  orderDiscounts {\n    edges {\n      node {\n        appliedAmount\n        amount\n        squareExternalId\n        id\n      }\n    }\n  }\n  lineItemGroups {\n    lineItems {\n      __typename\n      ... on BookingLineItem {\n        appliedDiscounts {\n          amountCents\n          squareExternalDiscountId\n        }\n      }\n      ... on RoundLineItem {\n        appliedDiscounts {\n          amountCents\n          squareExternalDiscountId\n        }\n      }\n      id\n    }\n    id\n  }\n  serviceCharges {\n    edges {\n      node {\n        __typename\n        amount\n        id\n      }\n    }\n  }\n}\n\nfragment useConsolidateNewPlayers_Booking on Booking {\n  __isBooking: __typename\n  rounds {\n    edges {\n      node {\n        __typename\n        player {\n          __typename\n          fullName\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useCurrentUserHasSeenNotificationNudgeModal_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Member {\n        user {\n          metadata {\n            hasSeenNotificationNudgeModal\n          }\n          id\n        }\n      }\n      ... on Customer {\n        user {\n          metadata {\n            hasSeenNotificationNudgeModal\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n\nfragment useGetBookingAnalyticsMetadata_booking on Booking {\n  __isBooking: __typename\n  type\n  startSlot {\n    __typename\n    type\n    agenda {\n      facility {\n        type\n        whooshBookingFee\n        whooshRoundFee\n        publicBookingPermissionSet {\n          prePaymentRequirement\n          id\n        }\n        department {\n          type\n          supportsPublic\n          club {\n            id\n            slug\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    status\n    durationMins\n  }\n  ... on LessonBooking {\n    status\n    durationMins\n  }\n  ... on DiningBooking {\n    status\n    partySize\n    dietaryTags\n    occasionTags\n    notesFromMember\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        courseLayout {\n          holeCount\n          id\n        }\n        transportationType {\n          code\n          id\n        }\n        player {\n          __typename\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useGetBookingCharge_Booking on Booking {\n  __isBooking: __typename\n  orders {\n    edges {\n      node {\n        lineItemGroups {\n          id\n          type\n          lineItems {\n            __typename\n            id\n            price\n            quantity\n            total\n            name\n            type\n            ... on BookingLineItem {\n              appliedDiscounts {\n                amountCents\n                squareExternalDiscountId\n              }\n            }\n            ... on RoundLineItem {\n              appliedDiscounts {\n                amountCents\n                squareExternalDiscountId\n              }\n            }\n          }\n        }\n        orderDiscounts {\n          edges {\n            node {\n              id\n              name\n              appliedAmount\n              amount\n              squareExternalId\n              lineItemGroupId\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useGetBookingFees_Booking on Booking {\n  __isBooking: __typename\n  orders {\n    edges {\n      node {\n        serviceCharges {\n          edges {\n            node {\n              __typename\n              amount\n              name\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useGetBookingRestrictionStatusesFragment on Booking {\n  __isBooking: __typename\n  __typename\n  restrictionStatuses {\n    groupStatuses {\n      statuses {\n        count\n        willViolate\n        rule {\n          __typename\n          id\n          name\n          ... on BookingRestrictionRule {\n            bookingType\n            displayName\n            memberMessage\n            memberOverride\n            staffOverride\n            countLimit {\n              countLimit\n              countUnit\n              qualifier\n              timeLimit\n              timeUnit\n              showNonViolating\n            }\n            bookingCriteria {\n              minPlayers\n              maxPlayers\n              id\n            }\n          }\n        }\n      }\n    }\n    roundStatuses {\n      statuses {\n        count\n        willViolate\n        rule {\n          __typename\n          id\n          name\n          ... on BookingRestrictionRule {\n            bookingType\n            displayName\n            memberMessage\n            memberOverride\n            staffOverride\n            countLimit {\n              countLimit\n              countUnit\n              qualifier\n              timeLimit\n              timeUnit\n              showNonViolating\n            }\n            bookingCriteria {\n              minPlayers\n              maxPlayers\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useGetFullfillableSlots_booking on Booking {\n  __isBooking: __typename\n  ... on StandardBooking {\n    fullfillableSlots {\n      id\n      time\n      availability\n      course {\n        name\n        id\n      }\n      slotRates: playerRates(type: CUSTOMER, highestPrecedentOnly: true) {\n        nineHolePrice: totalGolfPrice(holeCount: NINE)\n        eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n        rate {\n          __typename\n          name\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useGetIsBookingFull_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      capacity(bookingType: $bookingType)\n      usedCapacity\n    }\n    ... on QueueSlot {\n      capacity(bookingType: $bookingType)\n    }\n    id\n  }\n  rounds {\n    count\n  }\n}\n\nfragment useGetLineItemsAndPriceForRound_Round on Round {\n  __isRound: __typename\n  ... on CustomerRound {\n    paymentStatus\n  }\n  booking {\n    __typename\n    orders {\n      edges {\n        node {\n          status\n          id\n          lineItemGroups {\n            id\n            type\n            round {\n              __typename\n              id\n            }\n            lineItems {\n              id\n              __typename\n              type\n              name\n              price\n              ... on RoundLineItem {\n                appliedDiscounts {\n                  amountCents\n                  squareExternalDiscountId\n                }\n              }\n              ... on BookingLineItem {\n                appliedDiscounts {\n                  amountCents\n                  squareExternalDiscountId\n                }\n              }\n            }\n          }\n          orderDiscounts {\n            edges {\n              node {\n                id\n                name\n                appliedAmount\n                amount\n                squareExternalId\n                lineItemGroupId\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useGetRequestSummaryEstimation_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    ... on QueueSlot {\n      slotRates: playerRates(type: CUSTOMER, highestPrecedentOnly: true) {\n        nineHolePrice: totalGolfPrice(holeCount: NINE)\n        eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n      }\n    }\n    id\n  }\n}\n\nfragment useGetSummaryCalculations_Booking on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    prePaymentRequirement\n  }\n  id\n  __typename\n  totalDueAfterCredits\n  orders {\n    edges {\n      node {\n        status\n        total\n        orderPayments {\n          edges {\n            node {\n              amount\n              squareGiftCard {\n                id\n              }\n              id\n            }\n          }\n        }\n        ...getAggregatedOrderFinancialSummary_order\n        id\n      }\n    }\n  }\n}\n\nfragment useHasUnpublishedRequestRestrictions_slot on Slot {\n  __isSlot: __typename\n  __typename\n  ... on QueueSlot {\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n        }\n      }\n      id\n    }\n  }\n  ... on TimeSlot {\n    configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n      edges {\n        liftAt\n        requestCloses\n      }\n    }\n  }\n}\n\nfragment useInitializeCancelBookingModal_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  ... on StandardBooking {\n    durationMins\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  startSlot {\n    __typename\n    id\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n  }\n  rounds {\n    edges {\n      node {\n        id\n        __typename\n        transportationType {\n          id\n        }\n        courseLayout {\n          id\n        }\n        player {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on MemberRound {\n          nonPlayingHost\n        }\n      }\n    }\n  }\n}\n\nfragment useInitializeEditBookingModal_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  bookingSeries {\n    recurrenceType\n    repeatInterval\n    endCondition\n    effectiveEndDate\n    requestedOccurrenceCount\n    bookings(first: 366, orderBy: [{field: DATE_TIME, direction: DESC}]) {\n      edges {\n        node {\n          __typename\n          id\n          startSlot {\n            __typename\n            agenda {\n              date\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  startSlot {\n    __typename\n    id\n    agenda {\n      date\n      facility {\n        type\n        copyOverrides {\n          lessonPlayer {\n            singular\n          }\n          bookingPlayer {\n            singular\n          }\n        }\n        memberHoldEnabled\n        memberHoldDeadlineHours\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n      usedCapacity\n      bookingRates(highestPrecedentOnly: false, type: CUSTOMER, visibleToMembershipTypeId: $membershipTypeId) {\n        rate {\n          __typename\n          id\n          name\n          visibility\n          appliesToMembershipType(membershipTypeId: $membershipTypeId)\n        }\n      }\n    }\n    club {\n      defaultCustomerType {\n        id\n      }\n      id\n    }\n  }\n  ... on StandardBooking {\n    seriesCount\n    status\n    paymentStatus\n    request {\n      time\n      minTime\n      maxTime\n      bookingRule {\n        __typename\n        ... on RequestRule {\n          maxRequestCount\n        }\n        id\n      }\n      id\n    }\n    durationMins\n    startSlot {\n      __typename\n      ... on TimeSlot {\n        capacity(bookingType: $bookingType)\n        course {\n          id\n        }\n      }\n      ... on QueueSlot {\n        capacity(bookingType: $bookingType)\n      }\n      id\n    }\n  }\n  rate {\n    __typename\n    id\n  }\n  ... on LessonBooking {\n    seriesCount\n    request {\n      time\n      minTime\n      maxTime\n      bookingRule {\n        __typename\n        ... on RequestRule {\n          maxRequestCount\n        }\n        id\n      }\n      id\n    }\n    durationMins\n    lessonType {\n      id\n    }\n    instructors {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    startSlot {\n      __typename\n      ... on TimeSlot {\n        capacity(bookingType: $bookingType)\n        usedCapacity\n      }\n      ... on QueueSlot {\n        capacity(bookingType: $bookingType)\n      }\n      id\n    }\n  }\n  ownerClient {\n    __typename\n    ... on Customer {\n      id\n    }\n    ... on Member {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  rounds {\n    count\n    edges {\n      node {\n        id\n        bookingIndex\n        __typename\n        transportationType {\n          id\n        }\n        secondaryTransportationType {\n          id\n        }\n        manualPaymentStatus\n        bookedRate {\n          appliesToMembershipType\n          eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n          nineHolePrice: totalGolfPrice(holeCount: NINE)\n          rate {\n            __typename\n            id\n            name\n            visibility\n            ... on CustomerRate {\n              dynamicEnabled\n              dynamicOverridden\n            }\n          }\n        }\n        roundRate {\n          appliesToMembershipType\n          eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n          nineHolePrice: totalGolfPrice(holeCount: NINE)\n          rate {\n            __typename\n            id\n            name\n            visibility\n            ... on CustomerRate {\n              dynamicEnabled\n              dynamicOverridden\n            }\n          }\n        }\n        courseLayout {\n          id\n          holeCount\n        }\n        player {\n          __typename\n          id\n          firstName\n          lastName\n          ... on Customer {\n            membershipType {\n              id\n            }\n          }\n          ... on Member {\n            membershipType {\n              id\n            }\n            memberGroups {\n              id\n            }\n          }\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        paymentStatus\n        ... on MemberRound {\n          nonPlayingHost\n        }\n        ... on GuestRound {\n          host {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useInitializePunchPassesFromBooking on Booking {\n  __isBooking: __typename\n  id\n  ownerClient {\n    __typename\n    ... on Customer {\n      id\n    }\n    ... on Member {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  orders {\n    edges {\n      node {\n        id\n        lineItemGroups {\n          id\n          type\n          round {\n            __typename\n            id\n            player {\n              __typename\n              id\n            }\n          }\n          punchPass {\n            id\n            remainingPunchCount\n            client {\n              __typename\n              ... on Customer {\n                id\n                fullName\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            punchPassTemplate {\n              __typename\n              name\n              calculationType\n              type\n              id\n            }\n          }\n          punchPassesSelfValid: punchPassOptions(appliesTo: SELF, valid: true) {\n            id\n            remainingPunchCount\n            client {\n              __typename\n              ... on Customer {\n                id\n                fullName\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            punchPassTemplate {\n              __typename\n              name\n              calculationType\n              type\n              id\n            }\n          }\n          punchPassesOthersValid: punchPassOptions(appliesTo: OTHERS, valid: true) {\n            id\n            remainingPunchCount\n            client {\n              __typename\n              ... on Customer {\n                id\n                fullName\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            punchPassTemplate {\n              __typename\n              name\n              calculationType\n              type\n              id\n            }\n          }\n          punchPassesSelfInvalid: punchPassOptions(appliesTo: SELF, valid: false) {\n            id\n            remainingPunchCount\n            client {\n              __typename\n              ... on Customer {\n                id\n                fullName\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            punchPassTemplate {\n              __typename\n              name\n              calculationType\n              type\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useIsAnyDynamicRateOnBookingLocked_Booking on Booking {\n  __isBooking: __typename\n  ... on StandardBooking {\n    status\n    rounds {\n      edges {\n        node {\n          __typename\n          roundRate {\n            rate {\n              __typename\n              ... on CustomerRate {\n                dynamicOverridden\n              }\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useIsViewMoreVisible_Booking on Booking {\n  __isBooking: __typename\n  id\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        type\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n  orders {\n    edges {\n      node {\n        lineItemGroups {\n          round {\n            __typename\n            id\n          }\n          lineItems {\n            id\n            __typename\n            name\n            price\n            type\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...useGetBookingFees_Booking\n  ...useGetBookingCharge_Booking\n}\n\nfragment useRecurringRequestSeriesPreview_booking on Booking {\n  __isBooking: __typename\n  id\n}\n\nfragment useRequestRestrictionStatuses_booking on Booking {\n  __isBooking: __typename\n  requestRestrictionStatuses {\n    type\n    blockingScope\n    bookingIndex\n    label\n    startAt\n    endAt\n  }\n  startSlot {\n    __typename\n    id\n  }\n  ... on StandardBooking {\n    request {\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      id\n    }\n  }\n}\n\nfragment useShouldPresentBookingAsLockedRequest_booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n          node {\n            id\n            __typename\n            ... on RequestRule {\n              requestConfig {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "45938bd167c80e3c6f50fed94e9f7dd3";

export default node;
